import React from "react";

export const LOGO_WIDE =
  "https://customer-assets.emergentagent.com/job_onboard-collect/artifacts/t0vsb2iy_Sentry-1500x500.png";
export const LOGO_SQUARE =
  "https://customer-assets.emergentagent.com/job_onboard-collect/artifacts/4p3lr77j_Sentry-400x400.png";

export const BRAND = {
  primary: "#0F1644",
  primaryLight: "#1A2466",
  accent: "#00C7FF",
  accentDark: "#00A3D6",
  white: "#FFFFFF",
};

// Brand logo for LIGHT backgrounds (used on internal pages)
export default function Logo({ variant = "wide", className = "", style = {} }) {
  if (variant === "square") {
    return (
      <img src={LOGO_SQUARE} alt="Sentry Cloud IT" className={className}
        style={{ width: 48, height: 48, ...style }} data-testid="brand-logo-square"/>
    );
  }
  return (
    <img src={LOGO_WIDE} alt="Sentry Cloud IT — Speed Strength Security"
      className={className}
      style={{ height: 52, width: "auto", ...style }}
      data-testid="brand-logo-wide"/>
  );
}
